<template>
	<div
		class="g-block-title-box-accent g-block-title-padding"
		:class="{
			'g-block-title-box-accent--edit': editable,
			'is-active': editable && active,
			'g-block-title-box-accent--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-box-accent__wrap">
			<div class="g-block-title-box-accent__box" :style="{ borderColor: themeColor }">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-box-accent__text"
					fit-content
					:style="{ color: themeColor }"
					:model-value="data.content"
					placeholder="请输入标题"
					@update:model-value="onContentUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-box-accent__text"
					:style="{ color: themeColor }"
					v-html="data.content || ''"
				></div>
			</div>
			<span class="g-block-title-box-accent__accent" :style="{ background: themeColor }"></span>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { singleTitleMixin } from '../shared/singleTitleMixin.js';

	export default {
		name: 'GBlockTitleBoxAccent',
		components: { RichTextEditable },
		mixins: [singleTitleMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-box-accent {
		.title-block-edit-shell();
		text-align: center;
	}

	.g-block-title-box-accent__wrap {
		display: inline-flex;
		flex-direction: column;
		align-items: center;
		max-width: 100%;
	}

	.g-block-title-box-accent__box {
		padding: 10px 28px;
		border: 1px solid;
		box-sizing: border-box;
	}

	.g-block-title-box-accent__text {
		font-size: 18px;
		font-weight: 400;
		line-height: 1.3;
		text-align: center;
		:deep(.g-rich-text-editable__content) { min-height: unset; padding: 0; text-align: center; }
	}

	.g-block-title-box-accent__accent {
		display: block;
		width: 48px;
		height: 3px;
		margin-top: -1px;
	}

	.g-block-title-box-accent--h5 {
		.g-block-title-box-accent__box { padding: 0.2rem 0.56rem; }
		.g-block-title-box-accent__text { font-size: 0.36rem; }
		.g-block-title-box-accent__accent { width: 0.96rem; height: 0.06rem; margin-top: -0.02rem; }
	}
</style>
